module.exports = __webpack_public_path__ + "assets/img/c_addList.dd1390de.svg";